import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface TimeBasedSettingForAllCallersResponse extends MiddlewareAPIResponse
{
    
}

export class TimeBasedSettingForAllCallersResponseDtoImpl extends MiddlewareDtoImpl implements TimeBasedSettingForAllCallersResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersresponse.tsx